<template>
  <v-row class="d-flex align-center justify-center" no-gutters>
    <v-col cols="12" md="6" class="d-flex justify-center align-center">
      <!-- Logo Column -->
      <v-img 
        src="@/assets/gp21shopnobg.png" 
        alt="Logo" 
        max-width="300px" 
        class="logo-img" 
        contain 
      />
    </v-col>

    <v-col cols="12" md="6" class="pa-4 d-flex justify-center align-center">
      <!-- Login Form Column -->
      <v-card class="login-card" outlined>
        <v-card-title class="text-h4 text-center">Admin Login</v-card-title>

        <v-form @submit.prevent="submitLogin">
          <v-text-field
            v-model="form.email"
            label="Email"
            type="email"
            required
            outlined
            :rules="[emailRules]"
            placeholder="Enter your email"
            class="w-100"
          />
          <v-text-field
            v-model="form.password"
            label="Password"
            type="password"
            required
            outlined
            :rules="[passwordRules]"
            placeholder="Enter your password"
            class="w-100"
          />

          <v-btn
            type="submit"
            color="primary"
            class="login-btn w-100"
            :loading="isSubmitting"
            block
          >
            Login
          </v-btn>
        </v-form>

        <!-- Success Snackbar -->
        <v-snackbar v-model="snackbar.visible" :timeout="3000" color="success">
          {{ snackbar.message }}
          <template #action>
            <v-btn color="white" @click="snackbar.visible = false">Close</v-btn>
          </template>
        </v-snackbar>

        <!-- Error Snackbar -->
        <v-snackbar v-model="errorSnackbar.visible" :timeout="3000" color="error">
          {{ errorSnackbar.message }}
          <template #action>
            <v-btn color="white" @click="errorSnackbar.visible = false">Close</v-btn>
          </template>
        </v-snackbar>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      snackbar: {
        visible: false,
        message: ''
      },
      errorSnackbar: {
        visible: false,
        message: ''
      },
      isSubmitting: false,
      emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        v => v.length >= 6 || 'Password must be at least 6 characters'
      ]
    };
  },
  methods: {
    async submitLogin() {
      this.isSubmitting = true;
      try {
        this.errorSnackbar.visible = false; // Hide error snackbar

        const response = await this.$axios.post('/login', this.form);

        // Store token and user data
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data));

        // Show success notification
        this.snackbar.message = 'Login successful! Redirecting to the admin page...';
        this.snackbar.visible = true;

        // Redirect to the admin dashboard
        this.$router.push('/admin');
      } catch (error) {
        console.log('Error occurred during login:', error);

        if (error.response) {
          if (error.response.status == 401) {
            this.errorSnackbar.message = 'Invalid credentials. Please check your email and password.';
          } else if (error.response.status == 404) {
            this.errorSnackbar.message = 'The requested resource was not found.';
          } else {
            this.errorSnackbar.message = error.response.data.message || 'An unexpected error occurred.';
          }
        } else if (error.request) {
          this.errorSnackbar.message = 'No response from server. Please try again later.';
        } else {
          this.errorSnackbar.message = 'Error: ' + error.message;
        }
        this.errorSnackbar.visible = true; // Show error notification
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style scoped>
.v-row {
  min-height: 100vh; /* Ensure the row takes up full height */
  justify-content: center;
  align-items: center;
}

.v-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  padding: 2rem;
}

.logo-img {
  max-width: 300px;
  width: 100%;
  height: auto;
}

.v-card-title {
  margin-bottom: 30px;
  text-align: center;
}

.v-text-field {
  margin-bottom: 20px;
}

.v-btn {
  margin-top: 20px;
  font-weight: bold;
  text-transform: none;
  border-radius: 16px;  /* rounded corners */
  padding: 12px 0;  /* vertical padding */
  background-color: #002250;  /* button background color */
  color: white;
  font-size: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);  /* subtle shadow */
}

.v-btn:hover {
  background-color: #00478b;  /* hover background color */
}

.v-snackbar {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
</style>
